import React from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import Text from '../text/Text';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import './styles.css';
import Button from '../button/Button';

const images = [
    "/slideshow-images/_EXU0796.jpg",
    "/slideshow-images/_EXU0256.jpg",
    "/slideshow-images/_EXU0483.jpg",
    "/slideshow-images/_EXU0593.jpg",
    "/slideshow-images/_EXU0677.jpg",
    "/slideshow-images/_EXU0505.jpg"
    ];

    const settings = {
    dots: false, 
    infinite: true,
    speed: 500,
    slidesToShow: 1, 
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false, 
    };

export const SlideshowHome = () => {


    return (
        <div className='slideshow'>
            <div className='slideshow-gradient'>
                <div className='slideshow-content'>
                    <Text as='p'>O ÌmòLab é um espaço dedicado à promoção da inovação e excelência na interseção entre gestão e computação. O termo “ìmó”, originário do idioma iorubá, carrega consigo o significado de “saber” ou “conhecimento”.
                    Essa escolha linguística reflete nossa missão de cultivar e disseminar o saber por meio da pesquisa interdisciplinar, articulada com o ensino e a extensão.</Text>
                    <Link to='/sobre'>
                        <Button variant='transparent'>Saiba Mais</Button>
                    </Link>
                    
                </div>
            </div>
            <Slider {...settings} className='slider'>
                {images.map((img, index) => (
                <div key={index}>
                    <img 
                    src={img} 
                    alt={`Slide ${index + 1}`} 
                    className='slideshow-image'
                    />
                </div>
                ))}
            </Slider>
        </div>
    )
}

export const SlideshowAbout = () => {

    return (
        <div className='slideshow'>
            <div className='slideshow-gradient'>
                <div className='slideshow-content'>
                    <Text as='h1'>O Projeto ÌMÒLAB</Text>
                    <Text as='p' fontSize={18}>O ÌmòLab é um espaço dedicado à promoção da inovação e excelência na interseção entre gestão e computação. O termo “ìmó”, originário do idioma iorubá, carrega consigo o significado de “saber” ou “conhecimento”. Essa escolha linguística reflete nossa missão de cultivar e disseminar o saber por meio da pesquisa interdisciplinar, articulada com o ensino e a extensão.
                    <br />
                    <br />
                   </Text>
                    
                </div>
            </div>
            <Slider {...settings} className='slider'>
                {images.map((img, index) => (
                <div key={index}>
                    <img 
                    src={img} 
                    alt={`Slide ${index + 1}`} 
                    className='slideshow-image'
                    />
                </div>
                ))}
            </Slider>
        </div>
    )
}